<template>
    <layout-base>
        <div class="text-center ed-bg full-screen">
            <form class="form-signin" v-if="!recoverPasswordMode">
                <a href="http://www.cambialefacile.it">
                    <img class="mt-3 mb-3" src="../../assets/logo-cambialefacile_200-36.png">
                </a>
                <h1 class="h6 mb-3 font-weight-normal">Accedi al tuo account</h1>

                <label for="inputEmail" class="sr-only">E-mail</label>
                <input v-model="login.username" type="email" id="inputEmail" class="form-control" placeholder="E-mail"
                       required autofocus>
                <label for="inputPassword" class="sr-only">Password</label>
                <input v-model="login.password" type="password" id="inputPassword" class="form-control"
                       placeholder="Password" required>

                <label class="container">Ricordami<input type="checkbox">
                    <span class="checkmark"></span>
                </label>

                <button class="btn btn-lg btn-success btn-block" type="submit" @click.prevent="doLogin()">Accedi
                </button>

                <div v-if="loginError!=''" class="alert alert-danger" role="alert">
                    {{loginError}}
                </div>

                <p class="mt-4 mb-3 text-muted"> Non sei ancora registrato? </p>
                <!-- <button class="btn btn-lg btn-light btn-block" to="/register" block variant="btn btn-lg btn-light font-primary-ed">Registrati</button> -->
                <router-link to="/register" class="btn btn-lg btn-light btn-block ">Registrati
                </router-link>
                <a @click="recoverPasswordMode=true" class="recover-password">Password dimenticata?
                </a>
            </form>


            <form class="form-signin" v-if="recoverPasswordMode">
                <a href="http://www.cambialefacile.it">
                    <img class="mt-3 mb-3" src="../../assets/logo-cambialefacile_200-36.png">
                </a>
                <h1 class="h6 mb-3 font-weight-normal">Recupera Password</h1>

                <label for="inputEmail" class="sr-only">E-mail</label>
                <input v-model="email_recover_password" type="email" id="inputEmail" class="form-control"
                       placeholder="E-mail"
                       required autofocus>

                <div v-if="recoverSuccess!=''" class="alert alert-success" role="alert">
                    {{recoverSuccess}}
                </div>

                <button class="btn btn-lg btn-success btn-block " style="margin-top:10px;" type="submit"
                        @click.prevent="recoverPassword()">Recupera Password
                </button>

                <a @click="recoverPasswordMode=false" class="recover-password">Torna al login
                </a>
            </form>


            <p class="mt-5 mb-3 text-muted text-center"> all &copy; cambialefacile 2015-2019 </p>
        </div>
    </layout-base>
</template>

<script>
    // @ is an alias to /src
    import axios from 'axios'
    import LayoutBase from '@/components/layouts/LayoutBase'

    export default {
        name: 'Login',
        components: {
            LayoutBase: LayoutBase
        },
        data: function () {
            return {
                login: {},
                loginError: '',
                recoverPasswordMode: false,
                recoverSuccess: '',
                email_recover_password: null
            }
        },
        mounted: function () {
        },
        computed: {},
        methods: {
            recoverPassword: function () {
                var $vm = this

                if (!$vm.email_recover_password) {
                    return false
                }
//  console.log( "VUE_APP_API_BASE_URL"+process.env.VUE_APP_API_BASE_URL )
                axios.post(process.env.VUE_APP_API_BASE_URL + '/api/v1/user/request-link-recover-password', {email: $vm.email_recover_password})
                    .then(function (response) {
                        $vm.recoverSuccess= 'Controlla la tua casella di posta, è stato inviato un link per recuperare la tua password.'
                    }).catch(error => {

                    $vm.loginError = 'Dati di accesso errati, riprova.'
                });
            },
            doLogin: function () {
                var $vm = this

//  console.log( "VUE_APP_API_BASE_URL"+process.env.VUE_APP_API_BASE_URL )
                axios.post(process.env.VUE_APP_API_BASE_URL + '/api/v1/login', $vm.login)
                    .then(function (response) {
                        $vm.$cookies.set('token', response.data.token)
                        $vm.$cookies.set('user', response.data.user)
                        $vm.$router.push({name: 'amortizations'})
                    }).catch(error => {

                    $vm.loginError = 'Dati di accesso errati, riprova.'
                });
            }
        }
    }
</script>

<style scoped>
    /*Page Login - bg logo*/
    .bg-dark-ed {
        background-color: #222939 !important;
    }

    .recover-password {
        color: white !important;
        text-align: left !important;
        float: left;
        margin-top: 10px;
        cursor: pointer;
    }

    .alert {
        margin-top: 10px;
    }

    .full-screen {
        height: 100vh;
    }

    .custom-control-input {
        background-color: red;
    }

    /* :checked.custom-control-indicator  */

    .ed-bg {
        background-color: #272F44;
        background-color: #222939;
        color: white;
    }


    .font-primary-ed {
        color: #3A9275 !important;
    }

    /* preso da bootstrap */

    .form-signin {
        width: 100%;
        max-width: 330px;
        padding: 15px;
        margin: 0 auto;
    }

    .form-signin .checkbox {
        font-weight: 400;
    }

    .form-signin .form-control {
        position: relative;
        box-sizing: border-box;
        height: auto;
        padding: 10px;
        font-size: 16px;
    }

    .form-signin .form-control:focus {
        z-index: 2;
    }

    .form-signin input[type="email"] {
        margin-bottom: -1px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }

    .form-signin input[type="password"] {
        margin-bottom: 10px;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }


    /* checkbox */

    @media (min-width: 768px) {
        .container {
            max-width: 720px;
            padding-left: 40px;
        }
    }

    /* CHECKBOX  ------ */

    .container {
        display: block;
        position: relative;
        padding-left: 35px;

        margin-bottom: 12px;
        cursor: pointer;
        font-size: 22px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        /*cuper*/
        text-align: left;
        padding-left: 42px !important;
    }

    /* Hide the browser's default checkbox */
    .container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
        position: absolute;
        margin-top: 10;
        top: 0;
        left: 0;
        height: 25px;
        width: 25px;
        background-color: #eee;
        margin-top: 3px;
    }


    /* On mouse-over, add a grey background color */
    .container:hover input ~ .checkmark {
        background-color: #ccc;
        background-color: white;
    }

    /* When the checkbox is checked, add a blue background */
    .container input:checked ~ .checkmark {
        background-color: #3A9275;

    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .container input:checked ~ .checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .container .checkmark:after {
        left: 9px;
        left: 10px;
        top: 5px;
        top: 7px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    /* CHECKBOX  ------ End */
</style>
